import { FC } from "react";
import { IMilestone } from "../../../redux/challenges";
import { parsePlaceholders } from "../../../utils/format";
import styles from "./ChallengeTotalReward.module.scss";

interface IChallengeTotalRewardProps {
    milestones: IMilestone[];
}

export const ChallengeTotalReward: FC<IChallengeTotalRewardProps> = ({ milestones }) => {
    const rewardSums: { [key: string]: number } = {};

    milestones.forEach(item => {
        if (!item.reward || item.nonSum === true)
            return;
        
        Object.entries(item.reward).forEach(([rewardType, amount]) => {
            rewardSums[rewardType] = (rewardSums[rewardType] || 0) + amount;
        });
    });

    const rawRewards = Object.entries(rewardSums)
        .map(([rewardType, amount]) => `[${rewardType}] ${amount}`)
        .join(' ');

    return <p className={styles.reward}>{ parsePlaceholders(rawRewards) }</p>;
}
